import { Component } from '@angular/core';
import { NavController, NavParams, MenuController, Platform } from 'ionic-angular';
import { PlayPage } from '../play/play';
import { ReadstoryPage } from '../readstory/readstory';
import { HowToPage } from '../howto/howto';
import { SettingsPage } from '../settings/settings';
import { CollectiblesPage } from '../collectibles/collectibles';
import { Auth } from '../../providers/auth';
import { WorkInProgressPage } from '../workinprogress/workinprogress';
import { VersusPVPAsyncPage } from '../versuspvpasync/versuspvpasync';
import { VersusPVPsyncPage } from '../versuspvpsync/versuspvpsync';

import { Events, Slides } from 'ionic-angular';
import { ViewChild } from '@angular/core';

// ---- COMMON MODULES ---- //
import { Functions } from '../../providers/functions';
import { TranslateService } from '@ngx-translate/core';
import { SmartAudio } from '../../providers/smart-audio';
import { UserdataModel } from '../../providers/userdata-model';
import { GameModel } from '../../providers/game-model';
import { DataExchanger } from '../../providers/data-exchanger';
import { VersusAIPage } from '../versusai/versusai';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html',
  host: { '(window:resize)': 'handleResizeEvents($event)' }
})
export class HomePage {
  instext: string;
  showntext: string;
  settingsChanged: boolean;
  currentChunkProgress: number = 3;
  numBooksComingSoon;

  @ViewChild('homeslides') slides: Slides;

  constructor(public smartAudio: SmartAudio, public events: Events, public dataExchanger: DataExchanger, public auth: Auth, public navParams: NavParams, public platform: Platform, public rubedoSideMenu: MenuController, public userdataModel: UserdataModel, public playModel: GameModel, public functions: Functions, public translate: TranslateService, public navCtrl: NavController) {
    this.rubedoSideMenu = rubedoSideMenu;
    this.rubedoSideMenu.enable(true, 'rubedoSideMenu');
    this.functions.setSideMenuColorEnabled(true);
    this.settingsChanged = false;
    this.numBooksComingSoon = [];

    /* This reply to start over event to change page while doing the start over for doing it
    while showing complex pages killed the software. Who cares why? 
    The event is emitted in auth.ts in the startOver function */
    /*events.subscribe('startOverBegin', () => {
      // user and time are the same arguments passed in `events.publish(user, time)`
      this.navCtrl.setRoot(WorkInProgressPage, {});
    });
    events.subscribe('startOverEnd', () => {
      // user and time are the same arguments passed in `events.publish(user, time)`
      this.navCtrl.setRoot(HomePage, {});
    });*/
  }


  /* --------- LIFECYCLE --------- */
  ngOnInit() { // at the init of the page moment
    //this.slides.centeredSlides=true;

    if (!this.auth.barbicanEventActive) {
      this.slides.initialSlide = 0;
      this.slides.pager = true;
      this.slides.slidesPerView = 2;
      this.slides.paginationType = 'bullets';
      this.slides.loop = false; // This must be false cause there is an unresolved issue with true https://github.com/ionic-team/ionic/issues/10890

      this.platform.ready().then((readySource) => {
        if ((this.platform.width() < 550)) {
          this.slides.slidesPerView = 1;
        }
      });
    }

    //console.log("USERDATA:"+JSON.stringify(this.userdataModel.getWholeUserdata()));
    //console.log("GAMESDATA:"+JSON.stringify(this.playModel.getWholeGamesData()));
  }

  ionViewWillLeave() {
    //before the page leaves the viewport
    this.functions.setGameMode();
    this.functions.setLanguage();

    if (this.settingsChanged) {
      this.dataExchanger.storeUserGamedataOnServer(true);
      console.log("Setting changed... saving");
    }

    this.settingsChanged = false;
  }

  ionViewWillEnter() {
    //before the page in question becomes active
    this.functions.changeShowSidemenuButtonTo(true);
    this.functions.getGameMode();
    this.functions.getLanguage();

    this.rubedoSideMenu.enable(true, 'rubedoSideMenu');
    this.functions.setSideMenuColorEnabled(true);

    this.updateNumBooksComingSoon();

    /*var _this= this; // otherwise this cannot be seen in the scope of function() within setInterval
    var waitIntervalId = setInterval(
      function(){
        // Without this if the popup could happen when the page is changed
        if(_this.navCtrl.getActive().name=="HomePage"){
          //_this.functions.showWalkthroughWithMessage("walkthrough_1","superhappy");
        }
        clearInterval(waitIntervalId);
      },2000);  */
    /*if (this.navParams.get('firstAccessAfterLogin')) {
      this.functions.startBgMusic('app_BgMusic');
    } */
  }

  ionViewDidEnter() {
    this.functions.setScaleForBigScreen();
  }

  /* --------- END LIFECYCLE --------- */

  /* --------- FUNCTIONS --------- */
  handleResizeEvents(event: KeyboardEvent) {
    //Check for barbican event layout
    if (!this.auth.barbicanEventActive) {
      if ((event.target['innerWidth'] < 550)) {
        this.slides.slidesPerView = 1;
      } else {
        this.slides.slidesPerView = 2;
      }
      this.functions.setScaleForBigScreen();
    }
  }

  setLanguage(language) {
    this.functions.changeLanguageTo(language);
    this.userdataModel.setSettingsCurrentLanguage(this.functions.language);
    this.functions.setLanguage();

    this.updateNumBooksComingSoon();
    this.settingsChanged = true;
    this.goToFirstSlide();
  }

  setGamemode(gamemode) {
    console.log("Setting Gamemode: " + gamemode);
    this.userdataModel.setSettingsCurrentGamemode(gamemode);
    this.functions.setGamemodeTo(gamemode);

    this.updateNumBooksComingSoon();
    this.settingsChanged = true;
    this.goToFirstSlide();
  }

  /* Adds one or two greyed out books to viz if available books are lesser than two, just to fill the carousel */
  updateNumBooksComingSoon() {
    var numBooksAvailable = 0;
    for (let i = 0; i < this.functions.booksPlayable.length; i++) {
      if ((this.userdataModel.getLanguageofBook(this.functions.booksPlayable[i]) == this.functions.language)
        && (this.userdataModel.getGamemodeofBook(this.functions.booksPlayable[i]) == this.functions.gamemode)) {
        numBooksAvailable++;
      }
    }
    if (numBooksAvailable < 2) {
      if (numBooksAvailable == 0) {
        this.numBooksComingSoon = 2;
      }
      if (numBooksAvailable == 1) {
        this.numBooksComingSoon = 1;
      }
    } else {
      this.numBooksComingSoon = 0;
    }
  }

  goToPlay(chosenBook) {
    if (!this.userdataModel.isBookComplete(chosenBook)) {
      this.functions.setIdCurrentBook(chosenBook);
      //let currentIndex = this.slides.getActiveIndex();    
      this.navCtrl.push(PlayPage, {});
    }
  }

  goToReadStory(chosenBook) {
    this.functions.setIdCurrentBook(chosenBook);
    this.navCtrl.push(ReadstoryPage, {});
  }

  goToHowTo() {
    this.navCtrl.setRoot(HowToPage, {});
  }

  goToSettings() {
    this.navCtrl.setRoot(SettingsPage, {});
  }

  goToVersusAIPage() {
    this.navCtrl.setRoot(VersusAIPage, {});
  }

  goToVersusPVPAsyncPage() {
    this.navCtrl.setRoot(VersusPVPAsyncPage, {});
  }
  
  goToVersusPVPSyncPage() {
    this.navCtrl.setRoot(VersusPVPsyncPage, {});
  }

  goToCollectibles() {
    this.navCtrl.setRoot(CollectiblesPage, {});
  }

  addInstext() {
    this.showntext = this.showntext + ' ' + this.instext;
    this.instext = '';
  }

  prevSlide() {
    this.slides.slidePrev();
  }

  nextSlide() {
    this.slides.slideNext();
  }

  goToFirstSlide() {
    this.slides.slideTo(0);
  }
  /* --------- END FUNCTIONs --------- */
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts